import { useCallback } from 'react'
import { ImportUtilityModel } from '../typings'

type Props = {
  onClose: () => void
  onSave: (importDefaultValues: ImportUtilityModel) => void
}

export function useHandlers(props: Props) {
  const { onSave } = props

  const onSubmit = useCallback(
    async (model: ImportUtilityModel) => {
      onSave(model)
    },
    [onSave],
  )

  return {
    onSubmit,
  }
}
